<template>
  <div>
    <Teleport to="#appBody">
      <div class="fixed top-1/2 start-0 z-40">
        <RouterLink
          :to="{ name: 'BrowseServicesMainView' }"
          class="size-9 flex justify-center items-center bg-primary hover:shadow-lg"
        >
          <faMagicWand class="w-4 fill-white" />
        </RouterLink>
      </div>
    </Teleport>
    <router-view></router-view>
  </div>
</template>

<script setup>
import { useGlobalStore } from '@/stores/global'
import { usePublicServicesStore } from '@/stores/public_services'
import { computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import faMagicWand from '@/assets/icons/faMagicWand.svg?component'

const i18n = useI18n()
const globalStore = useGlobalStore()
const publicServicesStore = usePublicServicesStore()

const languageCode = computed(() => (i18n.locale.value == 'en' ? 2 : 1))

watch(i18n.locale, async () => {
  await publicServicesStore.getCategories({ forceFetch: true, languageCode: languageCode.value })
})

onMounted(async () => {
  await globalStore.getServicesList()
  await publicServicesStore.getCategories({ languageCode: languageCode.value })
})
</script>

<style lang="scss" scoped></style>
